import styled from "styled-components";
import { SearchOutlined } from "@ant-design/icons";
import { Input, Space, Col as AntCol, Image as AntImage } from "antd";
import { DefaultIMG } from '@assets';

export const RootContainer = styled.div`
position: relative;
`;

export const Container = styled.div`
padding: 16px;
`;

export const TabsWrapper = styled(Space)`
  margin-top: 12px;
  padding: 0 16px;
  width: calc(100% - 32px);
  overflow: auto;

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const Tab = styled.div`
padding: 8px 12px;
border-radius: 8px;
background-color: ${props => props.status === 'active' ? '#C21C05' : '#DEDEDE'};

font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: normal;
color: ${props => props.status === 'active' ? '#F7F7F7' : '#535B5D'};
overflow: hidden;
white-space: nowrap;
cursor: pointer;
`;

export const SearchInput = styled(Input).attrs({
  prefix: <SearchOutlined />
})`
margin-bottom: 16px;
height: 44px;
padding: 10px 12px;
border-radius: 34px;
border: 1.5px solid #DEDEDE;

input {
    font-size: 16px !important;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: #7E8485;
}

.anticon {
    color: #DEDEDE;
    font-size: 24px;
    margin-right: 8px;
}

:hover, :focus {
    border-color: #DEDEDE !important;
    box-shadow: 0 0 0 2px rgba(222, 222, 222, 0.1) !important;
}
`;

export const Col = styled(AntCol)`
width: 20%;
text-align: center;

@media screen and (max-width: 386px) {
  width: 25%;
}
`;

export const Image = styled(AntImage).attrs({
  alt: "gameicon",
  fallback: DefaultIMG,
  preview: false,
})`
    width: 100%;
    border-radius: 8px;
    box-shadow: 0px 4px 19px 0px rgba(0, 0, 0, 0.10), 0px 2px 6px 0px rgba(0, 0, 0, 0.20);
    background: linear-gradient(to bottom, #D18228, #F6FF00);
    padding: 2px;
    object-fit: cover;
    aspect-ratio: 1;
    cursor: pointer;
  `;

export const Text = styled.div`
width: 100%;
padding-top: 8px;
display: inline-block;

font-size: 10px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #565656;
text-align: center;
cursor: pointer;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
`;

export const SpinWrapper = styled.div`
height: calc(100vh - 145px);
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
`;